import { render } from "./prc-input.vue?vue&type=template&id=615076f0&scoped=true&ts=true"
import script from "./prc-input.vue?vue&type=script&lang=ts"
export * from "./prc-input.vue?vue&type=script&lang=ts"

import "./prc-input.vue?vue&type=style&index=0&id=615076f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615076f0"]])

export default __exports__